import { Box, Container, styled } from "@mui/material"
import { FC, ReactNode } from "react"
import { selectImpersonateMessage } from "src/features/profile"
import { appConstants } from "../../features/shared-module/constants"
import { useAppSelector } from "../hooks"
import { MainAppbar } from "./MainAppbar"

const StyledContentContainer = styled(Container)(({ theme }) => ({
  paddingTop: "12px",
  paddingBottom: "12px",
  width: `100%`,
  marginTop: `${appConstants.mainAppBarHeight}px`,
  height: `calc(100vh - ${appConstants.mainAppBarHeight}px)`,
  overflowY: "auto",
  backgroundColor: theme.palette.grey[100],
}))

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const impersonateMessage = useAppSelector(selectImpersonateMessage)
  return (
    <Box>
      <MainAppbar />
      <StyledContentContainer maxWidth={false}>
        {impersonateMessage && (
          <Box
            data-testid="impersonate-banner"
            sx={{
              backgroundColor: "warning.main",
              color: "white",
              padding: "8px 16px",
              textAlign: "center",
              borderRadius: 2,
              mb: 1,
              fontSize: "0.8125rem",
              fontWeight: 500,
            }}
          >
            {impersonateMessage}
          </Box>
        )}
        {children}
      </StyledContentContainer>
    </Box>
  )
}
